import { getGas } from './gasDatabase';

export interface SafetyEvaluation {
  safe: boolean;
  warnings: string[];
  guidance: string[];
}

export function getSafetyWarnings(gasId: string, action: string): string[] {
  const gas = getGas(gasId);
  const warnings: string[] = [];

  if (gas.id === 'h2' && action.includes('ignite')) {
    warnings.push('Never test hydrogen in a sealed tube. Keep the tube pointing away from people.');
  }
  if (['cl2', 'so2', 'h2s', 'no2'].includes(gas.id)) {
    warnings.push('Use a fume cupboard and wear eye protection.');
  }
  if (gas.id === 'nh3') {
    warnings.push('Ammonia is pungent and irritating; waft gently rather than sniff directly.');
  }
  if (gas.id === 'hcl') {
    warnings.push('Hydrogen chloride is corrosive; do not inhale directly.');
  }
  if (action.includes('seal') || action.includes('closed')) {
    warnings.push('Never heat a sealed container. Pressure will build and the apparatus may burst.');
  }

  return warnings;
}

export function validateSafety(gasId: string, action: string): SafetyEvaluation {
  const warnings = getSafetyWarnings(gasId, action);
  const safe = !action.includes('seal-then-heat') && !action.includes('point-at-person');

  return {
    safe,
    warnings,
    guidance: safe
      ? ['Use proper ventilation and waft to smell the gas gently.']
      : ['Stop the action and correct the setup before proceeding.'],
  };
}
